import { errorRedText } from '@/src/card-linking/components/iframeStyles'

export default function ErrorPopup() {
    return (
        <p style={{ ...errorRedText }}>
            Sorry, that payment method is not eligible for this service. Please
            try a different card or choose another redemption option.
        </p>
    )
}
